import { graphql } from "react-relay";

export const eventSchedulerSuggestedRoomFragments = {
  room: graphql`
    fragment EventSchedulerSuggestedRoom_room on Room {
      roomId
      name
      orgId
      estimatedCapacity
      reportedCapacity
      locationId
    }
  `,
};
